import React, { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import { getImg } from '../../../../Utils/getImg';
import {
	getCurrencySymbol,
	loadState,
} from '../../../FlyfishComponents/flyfishutils/utils';
import { Carousel } from 'react-responsive-carousel';
import {
	BackwardCarousel,
	ForwardCarousel,
	SendIconButton,
	WhiteTick,
} from '../../../../Components/FeatureComponents/Buttons/IconButton/Icons';
type Props = {
	complementary: any;
	handleSubmit: Function;
	recommendationHeading:string;
	colorMode?:any;
	colorScale?:any;
};

const ComplementProducts = ({ complementary, handleSubmit,recommendationHeading,colorMode,colorScale }: Props) => {

	const displaySymbol = (currencyCode) => {
		return <>{getCurrencySymbol(currencyCode)}</>;
	};
	const [currentIndex, setCurrentIndex] = useState(0);

	const productContentFullscreen = (item, index) => {


		return (
			<>
				<div
					className={`ff-product-carousel-item ${colorMode}`}
					onClick={() => {
						handleSubmit(item.product_id, item.title);
					}}
				>
					<div style={{ height: '75%', display: 'flex', position: 'relative' }} className='ff-product-carousel-item-img'>
					<img
						src={
							item.media_link.length > 0
								? item.media_link
								: getImg('icons/no-image.png')
						}
						style={{
							objectFit: item.media_link.length > 0 ? 'cover' : 'scale-down',
						}}
					/>
				</div>
					<div className='ff-product-carousel-desc'>
						<div>
							<div className='ff-product-carousel-desc-complementary-enc'>{item.title}</div>
						</div>
						{item.price !== '0' && (
							<div>
								{displaySymbol(item.currency)} <s></s>
								{item.price}
							</div>
						)}
					</div>
				</div>
			</>
		);
	};
	return (
		<>
		<div className="ff-carousel-border"></div>
		<div className='ff-complement-product'>
			<div className='ff-complement-desc'>
				<div style={{fontSize:'20px'}}>{recommendationHeading}</div>
			</div>
			<div className='ff-product-carousel'>
			<Carousel
				onChange={(index) => {
					setCurrentIndex(index);
				}}
				showStatus={false}
				swipeable={true}
				showIndicators={false}
				showArrows={complementary.length > 2 ? true : false}
				showThumbs={false}
				centerMode={true}
				centerSlidePercentage={80}
				onSwipeEnd={(event) => {
					console.log(event);
				}}
				renderArrowNext={(onClickHandler, hasNext) =>
					complementary.length > 2 && window.innerWidth <= 1280 &&
					currentIndex != complementary.length - 1 && (
						<button
							className={`carouselButtons clickable right ${colorMode} `}
							onClick={onClickHandler}
							style={{
								top: '31%',
								right: '6px',
								boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.28)',
							}}
						>
							{/* <ArrowRight /> */}
							<ForwardCarousel
								fill={
									colorMode === 'dark' ? 'var(--selectedColor)' : colorScale[2]
								}
							/>
						</button>
					)
				}
				renderArrowPrev={(onClickHandler, hasPrev) =>
					complementary.length > 2 && window.innerWidth <= 1280 && 
					currentIndex !== 0 && (
						<button
							className={`carouselButtons clickable left ${colorMode}`}
							onClick={onClickHandler}
							style={{
								top: '31%',
								left: '24px',
								boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.28)',
							}}
						>
							{/* <ArrowLeft /> */}
							<BackwardCarousel
								width='24px'
								height='24px'
								fill={
									colorMode === 'dark' ? 'var(--selectedColor)' : colorScale[2]
								}
							/>
						</button>
					)
				}
			>
				{complementary.map((item, index) => {
					return productContentFullscreen(item, index);
				})}
			</Carousel>
		</div>
		</div>
		</>
	);
};

export default ComplementProducts;
